import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import { Commanders } from './components/commanders/Commanders';
import { LeaderBoard } from './components/leaderboard/LeaderBoard';
import React, { Suspense } from 'react';
import { Users } from './components/users/Users';
import AppBody from './AppBody';
import { FAQ } from './components/faq/FAQ';
import { Changelog } from './components/changelog/Changelog';
import ErrorBoundary from './components/ErrorBoundary';
import { CommanderDetails } from './components/commanders/CommanderDetails';
import { AuthorDetails } from './components/authors/AuthorDetails';
import { Menu, ProgressCircle } from '@adobe/react-spectrum';
import { Deck } from './components/deck/Deck';
import { SearedLoader } from './components/genericLoadingDialog/SearedLoader';
import { Meta } from './components/meta/Meta';
import { Algorithm } from './components/algorithm/Algorithm';
import { Archetypes } from './components/archetypes/Archetypes';
import { PowerLevels } from './components/powerlevels/PowerLevels';
import LinkedAccountsContainer from './components/linkedAccounts/LinkedAccountsContainer';
import ManageDecksContainer from './components/manageDecks/ManageDecksContainer';
import SettingsContainer from './components/settings/SettingsContainer';
import { UserDetails } from './components/user/UserDetails';
import { VerifyEmail } from './components/auth/VerifyEmail';

const PlaytestPage = React.lazy(() => import('./components/playtest/PlaytestPage'));

export default function AppRouter(props) {
    const router = createBrowserRouter([
        {
            element: (
                <ErrorBoundary route={'*'}>
                    <AppBody />
                </ErrorBoundary>
            ),
            children: [
                {
                    path: '/',
                    element: (
                        <ErrorBoundary route={'/'}>
                            <LeaderBoard />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'details/deck/:id/playtest',
                    element: (
                        <ErrorBoundary route={'playtest'}>
                            <Suspense fallback={<SearedLoader size="large" subcaption="Warming up the playtest engine…" />}>
                                <PlaytestPage />
                            </Suspense>
                        </ErrorBoundary>
                    ),
                },
                {
                    path: '/details/*',
                    element: (
                        <ErrorBoundary route={'details/*'}>
                            <Deck />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'commanders',
                    element: (
                        <ErrorBoundary route={'commanders'}>
                            <Commanders />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'commanders/id/*',
                    element: (
                        <ErrorBoundary route={'commanders/id/*'}>
                            <CommanderDetails />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'archetypes',
                    element: (
                        <ErrorBoundary route={'archetypes'}>
                            <Archetypes />
                        </ErrorBoundary>
                    ),
                },
                // {
                //     path: 'cards',
                //     element: (
                //         <ErrorBoundary route={'cards'}>
                //             <Card />
                //         </ErrorBoundary>
                //     ),
                // },
                // {
                //     path: 'cards/id/*',
                //     element: (
                //         <ErrorBoundary route={'cards/id/*'}>
                //             <Card />
                //         </ErrorBoundary>
                //     ),
                // },
                {
                    path: 'users',
                    element: (
                        <ErrorBoundary route={'users'}>
                            <Users />
                        </ErrorBoundary>
                    ),
                },
                {
                    // Browse-by-author was replaced with browse-by-users.
                    // Preserve old bookmarks by redirecting /authors → /users.
                    path: 'authors',
                    element: <Navigate to="/users" replace />,
                },
                {
                    // Author-detail pages remain — still linked from deck
                    // pages, just no longer reachable from a list.
                    path: 'authors/id/*',
                    element: (
                        <ErrorBoundary route={'authors/id/*'}>
                            <AuthorDetails />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'faq',
                    element: (
                        <ErrorBoundary route={'faq'}>
                            <FAQ />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'changelog',
                    element: (
                        <ErrorBoundary route={'changelog'}>
                            <Changelog />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'meta',
                    element: (
                        <ErrorBoundary route={'meta'}>
                            <Meta />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'algorithm',
                    element: (
                        <ErrorBoundary route={'algorithm'}>
                            <Algorithm />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'powerlevels',
                    element: (
                        <ErrorBoundary route={'powerlevels'}>
                            <PowerLevels />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'linkedAccounts',
                    element: (
                        <ErrorBoundary route={'linkedaccounts'}>
                            <LinkedAccountsContainer />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'managedecks',
                    element: (
                        <ErrorBoundary route={'managedecks'}>
                            <ManageDecksContainer />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'settings',
                    element: (
                        <ErrorBoundary route={'settings'}>
                            <SettingsContainer />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'verify-email',
                    element: (
                        <ErrorBoundary route={'verify-email'}>
                            <VerifyEmail />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'user/id/*',
                    element: (
                        <ErrorBoundary route={'user'}>
                            <UserDetails />
                        </ErrorBoundary>
                    ),
                },
                {
                    path: 'user',
                    element: (
                        <ErrorBoundary route={'LeaderBoard'}>
                            <LeaderBoard />
                        </ErrorBoundary>
                    ),
                },
                // {
                //     path: 'pods',
                //     element: (
                //         <ErrorBoundary route={'pods'}>
                //             <Pods />
                //         </ErrorBoundary>
                //     ),
                // },
                // {
                //     path: 'pods/id/*',
                //     element: (
                //         <ErrorBoundary route={'pods/id/*'}>
                //             <Pods />
                //         </ErrorBoundary>
                //     ),
                // },
            ],
        },
    ]);

    function Root() {
        return (
            <Routes>
                {/* ⬆️ Blog splat route lifted */}
                <Route path="/" element={<LeaderBoard />} />
            </Routes>
        );
    }

    function Details() {
        return (
            <Routes>
                {/* ⬆️ Blog index route lifted */}
                <Route path="details" element={<LeaderBoard />} />
            </Routes>
        );
    }

    return <RouterProvider router={router} fallbackElement={<ProgressCircle isIndeterminate size="L" />} />;
}
